const entitiesSelector = (state) => state.entities;
const entitiesSelectorWithoutReferences = (state) => state.entities?.entities;
export {
  entitiesSelector,
  entitiesSelectorWithoutReferences
};
//# sourceMappingURL=selectors.js.map
